import styled from '@emotion/styled';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: var(--${(props) => props.color === 'success' ? 'success-color' : 'primary-color'});
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  max-width: 35rem;
  width: 100%;
  font-weight: 600;

  @media (max-width: 500px) {
    font-size: 13px;
  }
  
  @media (max-width: 400px) {
    font-size: 11px;
  }
`;

const Message = styled.p`
  margin-bottom: 1.5rem;
  white-space: pre-line;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;

const CancelButton = styled.button`
  background-color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #ec4899;
  }
`;

const ConfirmButton = styled.button`
  background-color: white;
  color: black;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #ec4899;
  }
`;

export { Overlay, ModalContainer, Message, ButtonGroup, CancelButton, ConfirmButton }